import useReveal from "@/lib/useReveal";

export default function Disclaimer() {
  useReveal();
  return (
    <main data-testid="page-disclaimer">
      <section className="pt-16 md:pt-20 pb-10 md:pb-14 bg-gradient-to-b from-navy-50/40 to-transparent">
        <div className="container-narrow">
          <div className="text-[12px] tracking-[0.22em] uppercase text-gold-500 font-medium reveal">
            Transparency Statement
          </div>
          <h1 className="font-serif-display text-4xl md:text-6xl text-navy-800 mt-3 leading-[1.04] tracking-tight reveal">
            Our commitment to clarity.
          </h1>
        </div>
      </section>

      <section className="py-10 md:py-16">
        <div className="container-narrow max-w-3xl text-slate-700 text-[16px] leading-[1.8] space-y-6 reveal">
          <p>
            St. John Accounting & Tax (a service offering of St. John Financial
            Group, Inc.) is committed to delivering accounting and tax services
            with full transparency, integrity, and care.
          </p>
          <p>
            All work is performed in accordance with the standards set by IRS
            Circular 230, the Oklahoma Board of Accountancy, and the Oklahoma
            Tax Commission. Recommendations are tailored to each client and
            always guided by professional standards and ethical requirements.
          </p>
          <p>
            We do not guarantee specific tax outcomes. Our objective is to
            identify and implement strategies that comply with current laws and
            support your long-term financial goals.
          </p>
          <p>
            For questions about this statement, the services we provide, or our
            professional standards, please contact David St. John at{" "}
            <a className="text-navy-800 underline decoration-gold-400/60 hover:decoration-navy-800" href="mailto:David@stjohnfinancialgroup.com">
              David@stjohnfinancialgroup.com
            </a>
            .
          </p>
        </div>
      </section>
    </main>
  );
}
